import request from "@/utils/request";

// 列表
export function getList(data) {
  return request({
    url: "/api/examination/get",
    method: "post",
    data,
  });
}
// 添加
export function addItem(data) {
  return request({
    url: "/api/examination/add",
    method: "post",
    data,
  });
}
// 编辑
export function editItem(id, data) {
  return request({
    url: "/api/examination/update",
    method: "post",
    data: { id, ...data },
  });
}
// 删除
export function delItem(data) {
  return request({
    url: "/api/examination/delete",
    method: "post",
    data,
  });
}
// 存档
export function documenItem(params) {
  return request({
    url: "/api/examination/documentation",
    method: "get",
    params,
  });
}